import React, { Component } from "react";
import {
  GT_Labels,
  GT_Seam_Allowance_Quality,
  GT_Notch,
  GT_Direction_Notch,
} from "../../Utilities/converterparamscnf.js";
import { currentLocals } from "../../languages/languages.js";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteIcon from "@mui/icons-material/Delete";
import { FormControl, FormLabel, Select, MenuItem, Switch, TextField, IconButton } from "@mui/material";
import { MuiMessageBox } from "@lectra/mui-library";
import { Typography } from "@mui/material";

export default class ConfigParam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paramValue: this.props.paramValue,
      askingDeleteParameter: false,
    };
  }

  AskDeleteParameter() {
    //Shows the MessageBox askingDeleteParameter
    //this.setState({ askingDeleteParameter: true });

    //Delete directly
    this.handleRemove(this.props.paramName);
  }

  OnOkDelete() {
    this.setState({ askingDeleteParameter: false });
    this.handleRemove(this.props.paramName);
  }
  OnCancelDelete() {
    this.setState({ askingDeleteParameter: false });
  }

  OnChangeTextFieldParamValue(event) {
    this.setState({ paramValue: event.target.value });
  }
  OnChangeSwitchParamValue(event) {
    this.setState({ paramValue: event.target.value });
  }
  OnUpdateParamValue(Paramvalue) {
    const { setConfigParam } = this.props;
    setConfigParam({
      converterid: this.props.converterid,
      convertertype: this.props.convertertype,
      paramid: this.props.paramName,
      paramvalue: Paramvalue,
    });
  }
  renderSelectValues(paramName, paramValue) {
    let values = [];
    let validationValue = false;

    //Verificamos ademas si el valor por defecto es "KIO_NO_TOOL", cuando debe ser algo
    let paramNameToShow = "";
    let paramValueToShow = "";
    let bParamValueDefaultHasChanged = false;
    let paramValueToStore;

    if (paramName.search("GT_DIRECTION_NOTCH_AUTO_ORIENTE") === 0) {
      values = GT_Direction_Notch;
      validationValue = true;
      if (paramValue === "KIO_NO_TOOL") {
        paramValueToShow = GT_Direction_Notch[0];
        bParamValueDefaultHasChanged = true;
      } else paramValueToShow = paramValue;
    } else if (paramName.search("GT_DIRECTION_NOTCH_ORIENTE") === 0) {
      values = GT_Direction_Notch;
      validationValue = true;
      if (paramValue === "KIO_NO_TOOL") {
        paramValueToShow = GT_Direction_Notch[0];
        bParamValueDefaultHasChanged = true;
      } else paramValueToShow = paramValue;
    } else if (paramName.search("SEAM_ALLOWANCE_QUALITY") === 0) {
      values = GT_Seam_Allowance_Quality;
      validationValue = true;
      paramValueToShow = paramValue;
      paramValueToStore = paramValueToShow;
    } else if (paramName.search("GT_NOTCH_AUTO_ORIENTE") === 0) {
      values = GT_Notch;
      validationValue = true;
      if (paramValue === "KIO_NO_TOOL") {
        paramValueToShow = GT_Notch[0];
        bParamValueDefaultHasChanged = true;
      } else paramValueToShow = paramValue;
      paramValueToStore = paramValueToShow;
    } else if (paramName.search("GT_NOTCH_ORIENTE") === 0) {
      values = GT_Notch;
      validationValue = true;
      if (paramValue === "KIO_NO_TOOL") {
        paramValueToShow = GT_Notch[0];
        bParamValueDefaultHasChanged = true;
      } else paramValueToShow = paramValue;
      paramValueToStore = paramValueToShow;
    } else if (paramName.search("NOTCH_IS_EXTERNAL") === 0) {
    } else if (paramName.search("NOTCH") === 0) {
      values = GT_Notch;
      validationValue = true;
      if (paramValue === "KIO_NO_TOOL") {
        paramValueToShow = GT_Notch[0];
        bParamValueDefaultHasChanged = true;
      } else paramValueToShow = paramValue;
      paramValueToStore = paramValueToShow;
    }

    // En GT_LABEL_ no lo consideramos, puesto que KIO_NO_TOOL, es un valor permitido
    else if (paramName.search("GT_LABEL_") === 0) {
      values = GT_Labels;
      validationValue = true;
      /*
      if (paramValue === "KIO_NO_TOOL") {
        paramValueToShow = GT_Labels[0];
        bParamValueDefaultHasChanged = true;
      } else paramValueToShow = paramValue;
      */
      paramValueToShow = paramValue;
      paramValueToStore = paramValueToShow;
    }

    paramNameToShow = paramName;

    if (bParamValueDefaultHasChanged) {
      /*Si se ha cambiado algo, lo actualizamos: cuando cambiamos el valor por defecto de KIO_NO_TOOL
     
      */
      //this.handleUpdate(event, paramName);

      const { setConfigParam } = this.props;
      let value = paramValueToShow;

      let id = paramName;

      let convertertype = document.getElementById("converterconfigId").getAttribute("convertertype");
      let converterId = document.getElementById("converterconfigId").getAttribute("converterid");

      setConfigParam({
        converterid: converterId,
        convertertype: convertertype,
        paramid: id,
        paramvalue: value,
      });
    }

    return (
      <Select
        value={paramValue}
        defaultValue={paramValueToShow}
        onChange={(event) => this.OnUpdateParamValue(event.target.value)}
      >
        {values.map((value) => (
          <MenuItem key={`dropdownLabelsValues_${this.props.paramName}${value}`} value={value}>
            {currentLocals(this.props.locale).configparams[value] !== undefined
              ? currentLocals(this.props.locale).configparams[value]
              : value}
          </MenuItem>
        ))}
      </Select>
    );
  }
  renderValueParam(paramName, paramValue) {
    //Poner una función que esta comprobación la englobe IsBooleanParam;
    if (paramName.search("COMPUTE_QUALITY_ZONE") === 0 || paramName.search("NOTCH_IS_EXTERNAL") === 0) {
      //Boolean
      let CheckLabelValue =
        paramValue === "YES"
          ? currentLocals(this.props.locale).configparams.On
          : currentLocals(this.props.locale).configparams.Off;

      return (
        <div>
          <Switch
            defaultChecked={paramValue === "YES" ? true : false}
            onChange={(event) => this.OnUpdateParamValue(event.target.checked ? "YES" : "NO")}
          ></Switch>
          <FormLabel sx={{ m: 1, width: 20 }}>{CheckLabelValue}</FormLabel>
        </div>
      );
    } else if (
      //Poner una función que esta comprobación la englobe; IsValidationParam
      paramName.search("GT_DIRECTION_NOTCH_AUTO_ORIENTE") === 0 ||
      paramName.search("GT_DIRECTION_NOTCH_ORIENTE") === 0 ||
      paramName.search("SEAM_ALLOWANCE_QUALITY") === 0 ||
      paramName.search("GT_NOTCH_AUTO_ORIENTE") === 0 ||
      paramName.search("GT_NOTCH_ORIENTE") === 0 ||
      paramName.search("NOTCH_IS_EXTERNAL") === 0 ||
      paramName.search("NOTCH") === 0 ||
      paramName.search("GT_LABEL_") === 0
    ) {
      //Validation Select
      return this.renderSelectValues(paramName, paramValue);
    } else if (
      //Poner una función que esta comprobación la englobe IsValueParam;
      paramName.search("SEAM_ALLOWANCE_VALUE") === 0 ||
      paramName.search("AUTO_CLOSE_QUALITY_ZONE_DISTANCE") === 0 ||
      paramName.search("FABRIC_REPEAT_X") === 0 ||
      paramName.search("FABRIC_REPEAT_Y") === 0
    ) {
      //text
      return (
        <div>
          <TextField
            type="text"
            sx={{ width: 80 }}
            value={this.state.paramValue}
            onChange={(event) => this.OnChangeTextFieldParamValue(event)}
            onBlur={(event) => this.OnUpdateParamValue(this.state.paramValue)}
          ></TextField>
          <FormLabel sx={{ m: 1, width: 20 }}>{currentLocals(this.props.locale).configparams.milimeters}</FormLabel>
        </div>
      );
    }
  }

  handleMoveParam(key, isMoveUp) {
    let { converterconfig } = this.props;
    let obj = converterconfig;
    if (key && obj) {
      var o = {};
      var idx;
      var keys = Object.keys(obj);
      var k;
      if ((idx = keys.indexOf(key)) > -1) {
        if ((!isMoveUp && idx + 1 == keys.length) || (isMoveUp && idx == 0)) {
          return [false, "there is no space to move"];
        } else {
          for (var f = 0; f < keys.length; f++) {
            if (isMoveUp && idx - 1 === f) {
              k = keys[idx];
              o[k] = obj[k];
              k = keys[f];
              o[k] = obj[k];
              f++;
            } else if (!isMoveUp && idx === f) {
              k = keys[f + 1];
              o[k] = obj[k];
              k = keys[f];
              o[k] = obj[k];
              f++;
            } else {
              k = keys[f];
              o[k] = obj[k];
            }
          }
        }
        const { setConfigConverter } = this.props;
        setConfigConverter({
          converterid: this.props.converterid,
          convertertype: this.props.convertertype,
          configuration: o,
        });
      }
    }
  }
  handleRemove = (paramName) => {
    const { removeConfigParam } = this.props;
    let convertertype = document.getElementById("converterconfigId").getAttribute("convertertype");
    let converterId = document.getElementById("converterconfigId").getAttribute("converterid");
    removeConfigParam({
      converterid: this.props.converterid,
      convertertype: this.props.convertertype,
      paramid: this.props.paramName,
    });
  };
  render() {
    //<ConfigParam index={index} paramName={key} paramValue={converterconfig[key]} key={key}></ConfigParam>
    let index = this.props.index;
    let sizeconverterconfig = this.props.sizeconverterconfig;
    return (
      <div id={this.props.paramName}>
        <FormLabel sx={{ m: 1, width: 350 }}>
          <Typography variant="body2" sx={{ color: "black", opacity: 0.87 }}>
            {this.props.paramName}
          </Typography>
        </FormLabel>
        <FormControl sx={{ marginLeft: 1, width: 350 }}>
          {this.renderValueParam(this.props.paramName, this.props.paramValue)}
        </FormControl>
        &nbsp;&nbsp;&nbsp;
        <IconButton>
          <ArrowUpwardIcon
            color={index === 0 ? "disabled" : "action"}
            cursor="pointer"
            onClick={() => {
              this.handleMoveParam(this.props.paramName, true);
            }}
          />
        </IconButton>
        &nbsp;&nbsp;&nbsp;
        <IconButton>
          <ArrowDownwardIcon
            color={index === sizeconverterconfig - 1 ? "disabled" : "action"}
            cursor="pointer"
            onClick={() => {
              this.handleMoveParam(this.props.paramName, false);
            }}
          />
        </IconButton>
        &nbsp;&nbsp;&nbsp;
        <IconButton>
          <DeleteIcon
            color="action"
            cursor="pointer"
            onClick={() => {
              /*this.handleRemove(this.props.paramName);*/
              this.AskDeleteParameter();
            }}
          />
        </IconButton>
        <MuiMessageBox
          // Message Box for confirm deletion
          open={this.state.askingDeleteParameter}
          alertType="undefined"
          content={currentLocals(this.props.locale).configparams.AskDeleteConfigParam + "\n" + this.props.paramName}
          lang="en-US"
          onClose={function noRefCheck() {}}
          primaryButton={{
            color: "primary",
            label: "Ok",
            onClick: () => this.OnOkDelete(),
          }}
          secondaryButtons={[
            {
              label: "Cancel",
              onClick: () => this.OnCancelDelete(),
            },
          ]}
          title={currentLocals(this.props.locale).converter.ConverterManagerDelete}
        />
      </div>
    );
  }
}
